import * as React from 'react';
import { Header as HeaderBase } from '../../components/Header';
import { PresetView } from '../types';
import { HelpTooltip } from './HelpTooltip';

interface Props {
  presetView: PresetView;
  containerCount: number;
}
export const Header: React.FC<Props> = (props) => {
  const { presetView, containerCount } = props;

  return (
    <HeaderBase presetView={presetView}>
      <h4>({containerCount})</h4>
      <HelpTooltip presetView={presetView} />
    </HeaderBase>
  );
};
Header.displayName = 'Shipments.Containers.Header';
